module.exports = __webpack_public_path__ + "img/49.4c150a61.jpg";